import { Ds } from "@accurx/design";
import { SkeletonLoader } from "@accurx/inbox-design-library/";
import { QuestionnaireTemplate } from "@accurx/message-templates";
import { PatientExternalId } from "@accurx/native";

import { StyledFetchingError, StyledReloadButton } from "./Templates.styles";
import { TemplatesBrowser } from "./components/TemplatesBrowser/TemplatesBrowser";
import { combineTemplates } from "./components/TemplatesCombobox/combineTemplates";
import { useAllPatientTemplates } from "./hooks/useAllPatientTemplates";

type TemplatesProps = {
    patientExternalIds: PatientExternalId[];
    disabled?: boolean;
    onQuestionnaireSelected?: (template: QuestionnaireTemplate) => void;
    onQuestionnaireRemoved?: () => void;
};

export const Templates = ({
    patientExternalIds,
    disabled,
    onQuestionnaireSelected,
    onQuestionnaireRemoved,
}: TemplatesProps) => {
    const templatesResult = useAllPatientTemplates({ patientExternalIds });

    if (templatesResult.status === "loading") {
        return <SkeletonLoader width="100%" height="20px" />;
    }

    if (templatesResult.status === "error") {
        return (
            <StyledFetchingError>
                <Ds.Flex alignItems={"center"}>
                    <Ds.Icon size="xsmall" name="Error" appearance="solid" />
                </Ds.Flex>
                <Ds.Text size="small" color="zinc">
                    Templates failed to load.
                </Ds.Text>
                <StyledReloadButton onClick={templatesResult.refetch}>
                    Reload templates
                </StyledReloadButton>
            </StyledFetchingError>
        );
    }

    const combinedTemplates = combineTemplates(templatesResult.data);

    return (
        <TemplatesBrowser
            templates={combinedTemplates}
            patientExternalIds={patientExternalIds}
            disabled={disabled}
            onQuestionnaireSelected={onQuestionnaireSelected}
            onQuestionnaireRemoved={onQuestionnaireRemoved}
        />
    );
};
